import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import {InstiService} from './insti.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private router: Router,
              private service: InstiService) { }
 // private isAuthenticated: boolean = false;


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    /*
     *  let excepts_urls=[this.service.getLoginUrl(true), this.service.getLogoutUrl(true)];
            var instance=this;
     */
    //  return true;
     
     var instance=this;
     if(!instance.service.getUser().isLogged()){
      if(this.router.url !== '/'){
        instance.service.showAlert('Você não tem permissão para acessar esta página', 'Faça o login e tente novamente.', 'error');
      }
      instance.router.navigate([instance.service.getLoginUrl(true)]);
    }


     if(instance.service.getUser().alterarSenha()){
        instance.service.showAlert('Bem vindo ao HabitApp!', 'Para continuar no sistema e usufruir de suas funcionalidades, você precisa alterar sua senha!', 'success');
        instance.router.navigate(['gestao-condominio/meus-dados']);
      }
      
        return true;
    }
}
